export default "__VITE_ASSET__CGer_M1F__"